import { render } from "./VerticalTabs.vue?vue&type=template&id=618f125c&ts=true"
import script from "./VerticalTabs.vue?vue&type=script&lang=ts"
export * from "./VerticalTabs.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__